import { render, staticRenderFns } from "./SidebarCard.vue?vue&type=template&id=4fbb370c&scoped=true"
import script from "./SidebarCard.vue?vue&type=script&lang=ts"
export * from "./SidebarCard.vue?vue&type=script&lang=ts"
import style0 from "./SidebarCard.vue?vue&type=style&index=0&id=4fbb370c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb370c",
  null
  
)

export default component.exports